/*
 * Controls the scroll behaviour of fixed scroll pages
 *
 * @author BarrelNY
 * @link https://github.com/alvarotrigo/fullPage.js
 *
 */

//Large args {} so keep in separate file
var Args = require('./scroll-options');

var Scroll = {
	init:function(){
		var templates = [
			'body.home-page',
			'body.U1-template',
			'body.U1-template-test'
		].join();

		if (!$(templates).length) return;

		//Attach callbacks
		Args['onLeave']     = this.onLeave.bind(this);
		Args['afterLoad']   = this.afterLoad.bind(this);
		Args['afterRender'] = this.afterRender.bind(this);

		this.events();

		$('#scroll-container').fullpage(Args);

		this.events(true);
	},

	events:function(belated){
		if (belated){
			$('a.scroll-prompt').click($.fn.fullpage.moveSectionDown);
		} else {
			$('body')
				.on('fullPage__disableInteractions',this.disableInteractions)
				.on('fullPage__enableInteractions',this.enableInteractions)
				.on('fullPage__rebuild',this.rebuild.bind(this));
		}
	},

	/*
	 * Trigger custom event. This event is listened
	 * to by other modules handling more
	 * specific functionality
	 * @params	void
	 * @returns	void
	 */
	afterLoad:function(anchorLink,index){
		$('body').trigger('fullPage__afterLoad',[anchorLink,index]);
	},

	/*
	 * Trigger custom event. This event is listened
	 * to by other modules handling more
	 * specific functionality
	 * @params	void
	 * @returns	void
	 */
	onLeave:function(index, nextIndex, direction){
		$('body').trigger('fullPage__onLeave',[index, nextIndex, direction]);
	},

	/*
	 * Called once, after all the supplimentary fullPage
	 * DOM elements are added and styled
	 * @params	void
	 * @returns	void
	 */
	afterRender:function(){
		$('body').trigger('fullPage__afterRender');
		$('body').addClass('fullpage-ready');
	},

	/*
	 * Disable scroll interactions
	 * @params	void
	 * @returns	void
	 */
	disableInteractions:function(){
		$.fn.fullpage.setKeyboardScrolling(false);
		$.fn.fullpage.setAllowScrolling(false);
	},

	/*
	 * Enable scroll interactions
	 * @params	void
	 * @returns	void
	 */
	enableInteractions:function(){
		$.fn.fullpage.setAllowScrolling(true);
		$.fn.fullpage.setKeyboardScrolling(true);
	},

	/*
	 * Rebuild the plugin to take
	 * changes to the DOM intro account
	 * @params	void
	 * @returns	void
	 */
	rebuild:function(){
		this.enableInteractions();
		$.fn.fullpage.reBuild();
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		$('a.scroll-prompt').off($.fn.fullpage.moveSectionDown);

		$.fn.fullpage.destroy('all');

		$('body')
			.off('fullPage__disableInteractions',this.disableInteractions)
			.off('fullPage__enableInteractions',this.enableInteractions)
			.off('fullPage__rebuild',this.rebuild);
	}
}

module.exports = Scroll;
